export const BITNET_PHONE_NUMBER = '+995 322 050022';
export const BITNET_TELEGRAM_LINK = 'https://t.me/bitnetge';
//# sourceMappingURL=contact.js.map